<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{ rowItem.operatedUserPO && rowItem.operatedUserPO.realName }}</div>
    <div class="item">修改时间：{{ rowItem.operatedTime }}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="item">商品名称：{{ form.beforeStr.name }}</div>
          <div class="item">商品编码：{{ form.beforeStr.productCode || '-' }}</div>
          <div class="item">曾用名：{{ form.beforeStr.usedName || '-' }}</div>
          <div class="item">SKU编码：{{ form.beforeStr.skuCode }}</div>
          <div class="item">单位：{{ form.beforeStr.unit || '-' }}</div>
          <div class="item">商品规格：{{ form.beforeStr.spec || '-' }}</div>
          <div class="item">零售单价：{{ form.beforeStr.price }}</div>
          <div class="item">库存：{{ form.beforeStr.inventory || 0 }}</div>
          <div class="item">库存同步时间：{{ fmtTime(form.beforeStr.inventorySyncTime) }}</div>
          <div class="item">主图：<el-image v-if="form.beforeStr.img" style="width:80px;height:80px" :src="form.beforeStr.img" :preview-src-list="[form.beforeStr.img]" /><span v-else>-</span></div>
          <div class="item">供应商：{{ form.beforeStr.supplier || '-' }}</div>
          <div class="item">税收分类编码：{{ form.beforeStr.taxCode || '-' }}</div>
          <div class="item">支持购买账户：{{ accountLabel(form.beforeStr.buyAccounts) }}</div>
          <div class="item">备注：{{ form.beforeStr.remark || '-' }}</div>
          <div class="item">排序：{{ form.beforeStr.sort }}</div>
          <div class="item">状态：{{ form.beforeStr.state === 1 ? '上架' : '下架' }}</div>
          <div class="item" v-if="form.beforeStr.visibleRoles">购买角色：{{ roleLabel(form.beforeStr.visibleRoles) }}</div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="item">商品名称：{{ form.afterStr.name }}</div>
          <div class="item">商品编码：{{ form.afterStr.productCode || '-' }}</div>
          <div class="item">曾用名：{{ form.afterStr.usedName || '-' }}</div>
          <div class="item">SKU编码：{{ form.afterStr.skuCode }}</div>
          <div class="item">单位：{{ form.afterStr.unit || '-' }}</div>
          <div class="item">商品规格：{{ form.afterStr.spec || '-' }}</div>
          <div class="item">零售单价：{{ form.afterStr.price }}</div>
          <div class="item">库存：{{ form.afterStr.inventory || 0 }}</div>
          <div class="item">库存同步时间：{{ fmtTime(form.afterStr.inventorySyncTime) }}</div>
          <div class="item">主图：<el-image v-if="form.afterStr.img" style="width:80px;height:80px" :src="form.afterStr.img" :preview-src-list="[form.afterStr.img]" /><span v-else>-</span></div>
          <div class="item">供应商：{{ form.afterStr.supplier || '-' }}</div>
          <div class="item">税收分类编码：{{ form.afterStr.taxCode || '-' }}</div>
          <div class="item">支持购买账户：{{ accountLabel(form.afterStr.buyAccounts) }}</div>
          <div class="item">备注：{{ form.afterStr.remark || '-' }}</div>
          <div class="item">排序：{{ form.afterStr.sort }}</div>
          <div class="item">状态：{{ form.afterStr.state === 1 ? '上架' : '下架' }}</div>
          <div class="item" v-if="form.afterStr.visibleRoles">购买角色：{{ roleLabel(form.afterStr.visibleRoles) }}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
import customerLevelApi from '@/api/sys/customerLevel'

export default {
  props: ['rowItem'],
  data() {
    return { form: null, levelMap: {} }
  },
  created() {
    customerLevelApi.fetchList({ levelSortSign: -1 }).then(({ data }) => {
      data.forEach(item => { this.levelMap[item.id] = item.name })
      this.getLogShow()
    })
  },
  methods: {
    fmtTime(val) {
      if (!val) return '-'
      return String(val).replace('T', ' ')
    },
    accountLabel(val) {
      if (!val) return '-'
      const map = { '1': '余额', '2': '零售价', '3': '学费' }
      return val.split(',').map(v => map[v] || v).join('、')
    },
    roleLabel(val) {
      if (!val) return '-'
      return val.split(',').map(v => this.levelMap[v] || v).join('、')
    },
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        const data = res.data || {}
        if (typeof data.beforeStr === 'string') { try { data.beforeStr = JSON.parse(data.beforeStr) } catch (e) {} }
        if (typeof data.afterStr === 'string') { try { data.afterStr = JSON.parse(data.afterStr) } catch (e) {} }
        this.form = data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title { font-size: 16px; font-weight: bold; margin-bottom: 10px; }
.log-line { border-left: 1px solid #e4e4e4; padding-left: 15px; }
.item { margin-bottom: 8px; color: #333; }
</style>
